import React from 'react';
import { Icon } from './Icon.js';
export const IconWindowFullScreenFill12 = ({ ...props }) => {
    return (React.createElement(Icon, { size: "12px", ...props },
        React.createElement("path", { d: "M9.25 1C10.7688 1 12 2.23122 12 3.75V8.25C12 9.76878 10.7688 11 9.25 11H2.75C1.23122 11 0 9.76878 0 8.25V3.75C0 2.23122 1.23122 1 2.75 1H9.25ZM3.75 4C3.33579 4 3 4.33579 3 4.75V7.25C3 7.66421 3.33579 8 3.75 8H8.25C8.66421 8 9 7.66421 9 7.25V4.75C9 4.33579 8.66421 4 8.25 4H3.75Z", fill: "currentColor" })));
};
//# sourceMappingURL=IconWindowFullScreenFill12.js.map